import {Component, OnInit} from '@angular/core';
import {FormGroup, FormsModule, Validators} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Service d'auth
import {AuthService} from '../../services/auth.service';

import { HttpClientModule } from '@angular/common/http';

import { MatSnackBar } from '@angular/material/snack-bar';
import {ActivatedRoute, RouterModule} from '@angular/router';
import {NavbarComponent} from "../../components/navbar/navbar.component";

@Component({
  selector: 'app-login',
  standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        InputTextModule,
        ButtonModule,
        HttpClientModule,
        MatProgressSpinnerModule,
        RouterModule,
        NavbarComponent
    ],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers: [AuthService],
})
export class RegisterComponent implements OnInit {
  password = '';
  password2 = '';

  public isLoading = false;

  private userToken: string = "";
  protected userName: string = "";

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {
  }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.userName = params["firstname"];
            this.userToken = params["token"];
        });
    }

  register() {
    this.isLoading = true;

    if(this.password != this.password2){
        this.snackBar.open('Erreur: Les mots de passe ne correspondent pas.', 'Fermer', {
            duration: 3000,
        });
        this.isLoading = false;
        return;
    }

    if(this.password.length < 12) {
        this.snackBar.open('Erreur: Le mot de passe doit faire au moins 12 caractères.', 'Fermer', {
            duration: 3000,
        });
        this.isLoading = false;
        return;
    }

    this.authService.register(this.getFormValues())
      .subscribe(
        (res) => {
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.snackBar.open("Une erreur est survenue lors de l'inscription. Votre mot de passe ne respecte pas les critères.", 'Fermer', {
            duration: 3000,
          });
        },
      );
  }



  getFormValues(): any {
    return { token: this.userToken, newPassword: this.password, newPasswordConfirm: this.password };
  }
}
